export default __webpack_public_path__ + "static/media/SENAIT_NL_EPILOG3.e63c5e21.mp3";